"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _clsx4 = _interopRequireDefault(require("clsx"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var _PrimaryContentColumn = _interopRequireDefault(require("./PrimaryContentColumn"));
var _excluded = ["left", "right", "anchorId"];
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    columnContainer: (0, _defineProperty2.default)({
      display: 'flex',
      flexDirection: 'column'
    }, theme.breakpoints.up('sm'), {
      flexDirection: 'row'
    }),
    column: (0, _defineProperty2.default)({
      width: '100%'
    }, theme.breakpoints.up('sm'), {
      width: 'calc(50% - (100% / 24))'
    }),
    leftColumnText: (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), {
      width: 'calc(36% - (100% / 24))'
    }),
    rightColumnLeftText: (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), {
      width: 'calc(64% - (100% / 24))'
    }),
    fullWidthColumn: {
      width: '100%'
    },
    displayNone: {
      display: 'none'
    },
    spacer: (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), {
      width: 'calc(100% / 12)'
    })
  };
});
var PrimaryContent = function PrimaryContent(_ref) {
  var _clsx, _clsx3;
  var left = _ref.left,
    right = _ref.right,
    anchorId = _ref.anchorId,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var classes = useStyles();
  if (!left && !right) {
    return null;
  }
  var hasLeftContent = left && left.content;
  var hasRightContent = right && right.content;
  var isLeftText = left.type === 'text';
  return __jsx("div", {
    className: "aem-ms-cmp aem-ms-primary-content ".concat(classes.columnContainer)
  }, __jsx("div", {
    className: (0, _clsx4.default)(classes.column, (_clsx = {}, (0, _defineProperty2.default)(_clsx, classes.leftColumnText, isLeftText), (0, _defineProperty2.default)(_clsx, classes.displayNone, !hasLeftContent), (0, _defineProperty2.default)(_clsx, classes.fullWidthColumn, !hasRightContent), _clsx))
  }, __jsx(_PrimaryContentColumn.default, left)), __jsx("span", {
    className: (0, _clsx4.default)(classes.spacer, (0, _defineProperty2.default)({}, classes.displayNone, !hasLeftContent || !hasRightContent))
  }), __jsx("div", {
    className: (0, _clsx4.default)(classes.column, (_clsx3 = {}, (0, _defineProperty2.default)(_clsx3, classes.displayNone, !hasRightContent), (0, _defineProperty2.default)(_clsx3, classes.rightColumnLeftText, isLeftText), (0, _defineProperty2.default)(_clsx3, classes.fullWidthColumn, !hasLeftContent), _clsx3))
  }, __jsx(_PrimaryContentColumn.default, right)));
};
var PrimaryContentEditConfig = {
  emptyLabel: 'Primary Content',
  isEmpty: function isEmpty(props) {
    if (props.left || props.right) {
      return false;
    } else {
      return true;
    }
  }
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/primarycontent')(PrimaryContent, PrimaryContentEditConfig);
exports.default = _default;